const endpoints = {
  users: {
    avatars: "/users/avatars",
    cities: "/users/cities/{country_id}",
    countries: "/users/countries",
    createAccount: "/users/create-account",
    currencies: "/users/currencies",
    firebaseLogin: "/users/firebase-login",
    languages: "/users/languages",
    logout: "/users/logout",
    profileSetup: "/users/profile-setup",
    profileSetupComplete: "/users/profile-setup/complete",
    refreshToken: "/users/refresh-token",
    resendOtp: "/users/resend-otp",
    sendOtp: "/users/send-otp",
    socialLogin: "/users/social-login",
    travelNodes: "/users/travel-nodes",
    userAccount: "/users/user-account",
    updateUserProfile: "/users/user-account",
    privacyPolicy: "/users/privacy-policy",
    termsAndConditions: "/users/terms-and-conditions",
    verifyOtp: "/users/verify-otp",
    home: "/users/home",
    trips: "/users/trips",
    tripDetail: "/users/trips/{booking_id}",
    tripTicket: "/users/trips/{booking_id}/ticket",
    tripInvoice: "/users/trips/{booking_id}/invoice",
    documents: "/users/documents", // GET, POST
    documentDetail: "/users/documents/{document_id}", // GET, PATCH, DELETE
    documentTypes: "/users/document-types", // GET
    documentsDownload: "/users/documents/{document_id}/download", // GET
    walletBalance: "/users/wallet", // GET ?include_transactions=true|false
    walletTransactions: "/users/wallet/transactions", // GET ?page=&page_size= (paginated: count, next, previous, data)
  },
  bookings: {
    airports: "/bookings/airports",
    searchHome: "/bookings/search/home",
    coupons: "/bookings/coupons",
    couponsValidate: "/bookings/coupons/validate",
    convenienceFeeCalculation: "/bookings/convenience_fee/calculation",
    rating: "/bookings/rating/",
    ratingView: "/bookings/ratings/view/{rating_id}",
    ratingUpdate: "/bookings/rating/{rating_id}/",
    ratingDelete: "/bookings/rating/{rating_id}/",
    ratingReply: "/bookings/rating/{rating_id}/reply/",
    ratingSummary: "/bookings/rating-summary/", // GET ?service=venue|hotel|event&object_id= — was path-param style, confirmed live 2026-09-23 to be query-param
    reviewList: "/bookings/rating/review", // GET ?service=&object_id=&page=&page_size= — paginated reviews + replies for an entity
  },
  flights: {
    status: "/flights/status",
    searchAirlines: "/flights/search/airlines",
    airports: "/flights/airports",
    search: "/flights/search",
    lockOptions: "/flights/lock/options",
    fareGroupDetails: "/flights/fare-group-details",
    travelChecklist: "/flights/travel-checklist",
    seatLayout: "/flights/seat-layout",
    itinerary: "/flights/itinerary",
    orders: "/flights/orders",
    orderPreparePayment: "/flights/orders/prepare-payment",
    orderConfirmPayment: "/flights/orders/confirm-payment",
    orderCouponValidate: "/flights/orders/{booking_id}/coupon/validate",
    orderCoupon: "/flights/orders/{booking_id}/coupon",
    orderCouponRemove: "/flights/orders/{booking_id}/coupon/remove",
    manage: "/flights/manage",
    manageDetail: "/flights/manage/{booking_id}",
  },
  wishlists: {
    list: "/wishlists/", // GET
    create: "/wishlists/", // POST
    join: "/wishlists/join/{token}/", // POST
    detail: "/wishlists/{wishlist_id}", // GET
    update: "/wishlists/{wishlist_id}", // PUT
    partialUpdate: "/wishlists/{wishlist_id}", // PATCH
    delete: "/wishlists/{wishlist_id}", // DELETE
    access: "/wishlists/{wishlist_id}/access", // GET
    accessCreate: "/wishlists/{wishlist_id}/access", // POST
    accessRecord: "/wishlists/{wishlist_id}/access/{access_id}", // GET
    accessDelete: "/wishlists/{wishlist_id}/access/{access_id}", // DELETE
    items: "/wishlists/{wishlist_id}/items", // GET
    itemsCreate: "/wishlists/{wishlist_id}/items", // POST
    item: "/wishlists/{wishlist_id}/items/{item_id}", // GET
    itemDelete: "/wishlists/{wishlist_id}/items/{item_id}", // DELETE
  },
  hotel: {
    search: "/hotels/hotel/search/",
    citySuggestion: "/hotels/hotel/city/suggestion/",
    content: "/hotels/hotel/content/",
    hotelRoom: "/hotels/hotel/room/rate/",
    booking: "/hotels/hotel/booking/",
    bookingVerify: "/hotels/hotel/booking/verify/",
    HotelFilter: "/hotels/hotel/filter/",
  },
  packages: {
    search: "/packages/search/",
    content: "/packages/content/",
    bookingSummary: "/packages/booking-summary/",
    placeBooking: "/packages/place-booking/",
    cancelBooking: "/packages/bookings/cancel/",
    verifyPayment: "/packages/bookings/payment/verify/",
  },
  cars: {
    locations: "/cars/locations",
    search: "/cars/search",
    details: "/cars/details",
    insurance: "/cars/insurance",
    book: "/cars/book",
    cancel: "/cars/cancel",
    bookingDetails: "/cars/booking-details",
    myBookings: "/cars/my-bookings",
    myBookingDetail: "/cars/my-bookings/{booking_id}",
    ticket: "/cars/my-bookings/{booking_id}/ticket",
    invoice: "/cars/my-bookings/{booking_id}/invoice",
  },
  blogs: {
    list: "/admin-panel/blogs/list",
    detail: "/admin-panel/blogs/view/{blog_id}",
    categories: "/admin-panel/blogs/category-list",
  },
  cruises: {
    ports: "/cruises/ports",
    lines: "/cruises/lines",
    ships: "/cruises/ships",
    search: "/cruises/search",
    details: "/cruises/details",
    contact: "/cruises/contact",
  },
  trains: {
    stationCodes: "/trains/station-codes/",
    list: "/trains/train-list/",
    classQuota: "/trains/class-quota/",
    live: "/trains/live/",
  },
  customerEvents: {
    list: "/customer_events/",
    categories: "/customer_events/categories/",
    artists: "/customer_events/artists/",
    detail: "/customer_events/{event_id}/",
    book: "/customer_events/book/",
    cancel: "/customer_events/bookings/{booking_id}/cancel/",
    guestCheckin: "/customer_events/guests/{guest_id}/checkin/",
    guestCheckout: "/customer_events/guests/{guest_id}/checkout/",
  },
  venues: {
    list: "/users/venues",
    filterOptions: "/users/venues/filters-options",
    detail: "/users/venues/{id}",
    freeSlots: "/users/venues/{id}/free-slots",
    events: "/vendors/venues/events/",
    requestProposal: "/vendors/user_app/request-proposal",
    requestProposalBulk: "/vendors/user_app/request-proposal/bulk",
    estimatePrice: "/vendors/user_app/request-proposal/estimate-price", // POST — {total_estimated_price, currency}
    suggestedVenues: "/vendors/user_app/proposals/{proposal_id}/suggested-venues",
    rfps: "/vendors/user_app/rfps",
    rfpQuotations: "/vendors/user_app/rfps/quotations",
    proposalDetail: "/vendors/user_app/proposals/{proposal_id}",
    proposalUpdate: "/vendors/user_app/proposals/{proposal_id}",
    proposalAction: "/vendors/user_app/proposals/{proposal_id}/action",
    proposalBook: "/vendors/user_app/proposals/{proposal_id}/book",
    proposalConfirmBookingDetails: "/vendors/user_app/proposals/{proposal_id}/confirm-booking-details",
    proposalsCompare: "/vendors/user_app/proposals/compare",
    applyCoupon: "/vendors/user_app/proposals/{proposal_id}/apply-coupon",
    removeCoupon: "/vendors/user_app/proposals/{proposal_id}/remove-coupon",
    applyWallet: "/vendors/user_app/proposals/{proposal_id}/apply-wallet",
    removeWallet: "/vendors/user_app/proposals/{proposal_id}/remove-wallet",
    paymentCheckout: "/vendors/user_app/proposals/{proposal_id}/payment/checkout",
    paymentVerify: "/vendors/user_app/proposals/{proposal_id}/payment/verify",
    bookingConfirmation: "/vendors/user_app/proposals/{proposal_id}/booking-confirmation", // keyed by quotation_id — already correct in venuePayment.jsx/venueBookingSuccess.jsx since their own :id param chains from venueProposalDetail's quotation_id
    paymentRemainingInstallments: "/vendors/user_app/payment/remaining-installments", // POST {quotation_id, gateway, pay_full} — first installment is paid at accept, this pays the next one (or all remaining if pay_full: true)
    negotiationMessages: "/vendors/venues/negotiations/{chat_room_id}/messages/", // GET/POST — keyed by chat_room_id now, not proposal/RFP id
  },
  adminPanel: {
    appOptions: "/admin-panel/app-options/list", // GET ?group=<code>
  },
  subscriptions: {
    me: "/subscriptions/me",
    plans: "/subscriptions/plans",
    subscribe: "/subscriptions/subscribe",
    verifyRazorpay: "/subscriptions/verify/razorpay"
  },
  splitwise: {
    groups: "/splitwise/groups/", // GET (list, ?filter=all|active|archive), POST (create)
    bookings: "/splitwise/bookings/", // GET — user's bookings, for the Create Group "Link Bookings" picker
    groupDetail: "/splitwise/groups/{group_id}/", // GET, PATCH, DELETE
    groupMembers: "/splitwise/groups/{group_id}/members/", // POST (add members)
    memberEmail: "/splitwise/members/{member_id}/email/", // PATCH
    memberDelete: "/splitwise/members/{member_id}/", // DELETE
    groupExpenses: "/splitwise/groups/{group_id}/expenses/", // GET (list), POST (add expense)
    expenseDetail: "/splitwise/expenses/{expense_id}/", // GET
    expenseSharePayment: "/splitwise/expense-shares/{share_id}/payment/", // PATCH
    bookingGuests: "/splitwise/bookings/guests/", // GET ?booking_ids=59,60
    join: "/splitwise/join/{token}/", // POST
    paymentReminder: "/splitwise/groups/{group_id}/payment-reminder/", // POST — optional {member_id}, omit for all pending members
    groupMessages: "/splitwise/groups/{group_id}/messages/", // GET (paginated, ?page=&page_size=), POST (send, multipart preferred)
  },
  notifications: {
    list: "/notifications/", // GET ?page=&page_size=&notification_type=&event_type=
    markRead: "/notifications/{id}/read/", // PATCH
    markAllRead: "/notifications/mark-all-read/", // POST
    delete: "/notifications/{id}/delete/", // DELETE
  }
};

export default endpoints;
